import React from "react";
import { Layout, Card, Col, Row } from "antd";

const { Content, Footer } = Layout;
const { Meta } = Card;
class SalesLedger extends React.Component {
  constructor(props) {
    super();
    this.state = {
      statistics: null,
    };
  }
  componentWillMount() {
    
    }

  render() {
  
    return (
        <h1>Sales Ledger</h1>
    );
  }
}

export default SalesLedger;




